<template>
  <div class="poi-wrapper">
    <div class="close-button" @click="goBack">
      <img src="../../assets/icons/cancel-24px.png" alt="close" />
    </div>
    <!-- <div id="poi-data" v-if="poiData" :class="{expanded: showMore}"> -->
    <div
      id="poi-data"
      v-if="poiData && !showRoutingMap"
      :class="{expanded: showMore}"
      :aria-hidden="showRoutingMap ? 'true' : 'false'"
    >
      <div class="cover-wrapper">
        <div class="cover" v-if="rotator.length > 0" :style="getCoverBackground()">
          <link rel="prefetch" as="image" v-for="img in rotator" :key="img" :href="hostAddress + img" />
          <img class="cover-img" :src="hostAddress + rotator[selected]" />
          <img class="cover-logo" v-if="poiData.logo" :src="hostAddress + poiData.logo" alt="logo" />
          <div class="arrowbox back" v-if="rotator.length > 1" @click="selected = (selected + 1) % rotator.length">
            <span class="material-icons-round">arrow_back_ios</span>
          </div>
          <div
            class="arrowbox forward"
            v-if="rotator.length > 1"
            @click="selected = (selected + rotator.length - 1) % rotator.length"
          >
            <span class="material-icons-round">arrow_forward_ios</span>
          </div>
        </div>
        <div class="poi-infos">
          <div class="poi-intro">
            <!-- <div class="poi-name">{{ poiData.name }}</div> -->
            <!-- buton fly  -->
            <div class="poi-header">
              <!-- ZONA 70%: NAME -->
              <div class="poi-name" :title="poiData.name">
                {{ poiData.name }}
              </div>
              <!--  30%: BUTTONS -->
              <div class="poi-actions">
                <button
                  v-if="isPointGeometry && !showRoutingMap && !$root.$data.embedded"
                  class="action-btn"
                  :title="$t('buttons.routing')"
                  @click="onRoutingClick"
                  aria-label="Routing"
                >
                  <img src="@/assets/icons/routing.png" alt="" class="action-icon" />
                  <span class="action-text"></span>
                </button>

                <div
                  v-if="isLineGeometry"
                  ref="flightControlContainer"
                  class="flight-control-mount"
                  aria-hidden="true"
                ></div>
              </div>
            </div>
            <div class="poi-address" v-if="poiData.address">
              {{ poiData.address[0] }}
            </div>
            <div class="poi-address" v-if="poiData.address">
              {{ poiData.address[1] }}
            </div>
            <div
              class="is-open-info"
              :class="{open: isOpened, expanded: isDesktop() || showMore}"
              v-if="poiData.opening_hours"
            >
              <i class="material-icons-round md-15 white">schedule</i>
              {{ isOpened ? $t("poiDetails.opened") : $t("poiDetails.closed") }}
            </div>
            <div class="poi-links" :class="{expanded: isDesktop() || showMore}">
              <div class="poi-link" v-if="poiData.contact.tel1">
                <a :href="'tel:' + poiData.contact.tel1">{{ poiData.contact.tel1 }}</a>
              </div>
              <div class="poi-link" v-if="poiData.contact.mail">
                <a :href="'mailto:' + poiData.contact.mail">{{ poiData.contact.mail }}</a>
              </div>
              <div
                class="poi-link"
                v-if="poiData.contact.website && !poiData.contact.website.includes('outdooractive')"
              >
                <a :href="poiData.contact.website" target="_blank">{{ websiteDisplay }}</a>
              </div>
            </div>
            <div class="attribution-info" v-if="poiData.attribution">
              <span>{{ $t("poiDetails.content") }} &copy; </span>
              <span v-html="poiData.attribution"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="more-infos-wrapper">
        <div
          ref="elevationContainer"
          class="height-profile"
          v-if="isLineGeometry"
          :style="{display: isWeatherMapActive ? 'block' : 'none'}"
          style="width: 100%; height: 110px"
        ></div>
        <div
          class="more-info"
          :class="{expanded: showMore}"
          v-show="poiData.opening_hours || poiData.long_info || elevations || (poiData.events && poiData.events.length)"
        >
          <!-- <div class="export-buttons" v-if="elevations">
            <a @click="exportTrack('gpx')">GPX</a>
            <a @click="exportTrack('geojson')">GeoJSON</a>
          </div> -->
          <!-- aici avem elevation in expanded:showMore-->
          <!-- <div ref="elevationContainer" 
              class="height-profile"   
              v-if="isLineGeometry" 
              :style="{ display: isWeatherMapActive ? 'block' : 'none' }"
              style="width: 100%; height: 110px;">
          </div> -->
          <!-- <div id="height-profile">
            <img
              v-if="elevationProfileImage"
              :src="elevationProfileImage"
              alt="Elevation Profile"
              :style="{ display: !isWeatherMapActive ? 'block' : 'none' }"
              style="max-width: 100%"
            />
          </div>  -->

          <div class="opening-schedule" v-if="poiData.opening_hours">
            <div class="time-info">{{ $t("poiDetails.openingHours") }}</div>
            <table class="opening-schedule">
              <tr class="working-days" v-for="day in weekDays" :key="day.id">
                <td>{{ $t("general." + day.toLowerCase()) }}</td>
                <td v-if="poiData.opening_hours[day].length > 0">
                  <div v-for="op in poiData.opening_hours[day]" :key="op[0]">{{ op[0] }} - {{ op[1] }}</div>
                </td>
                <td v-else>{{ $t("poiDetails.closed") }}</td>
              </tr>
            </table>
          </div>
          <div v-if="!hasEvents && hasMoreInfo" class="poi-info-only">
            <div class="time-info">{{ $t("poiDetails.moreInfo") }}</div>
            <div class="additional-info" v-html="poiData.long_info"></div>
          </div>

          <div v-if="hasEvents" class="poi-tabs">
            <div class="tab-buttons">
              <button v-if="hasMoreInfo" :class="{active: activeTab === 'info'}" @click="activeTab = 'info'">
                {{ $t("poiDetails.moreInfo") }}
              </button>

              <button v-if="hasEvents" :class="{active: activeTab === 'events'}" @click="activeTab = 'events'">
                Events
              </button>
            </div>

            <!-- MORE INFORMATION -->
            <div v-show="activeTab === 'info' && hasMoreInfo">
              <!-- <div class="time-info">{{ $t("poiDetails.moreInfo") }}</div> -->
              <div class="additional-info" v-html="poiData.long_info"></div>
            </div>

            <!-- EVENTS -->
            <div v-show="activeTab === 'events' && hasEvents" class="poi-events">
              <!-- <p class="poi-events"> Events</p> -->
              <div class="events-months">
                <button
                  v-for="month in months"
                  :key="month.key"
                  :class="{active: selectedMonth === month.key}"
                  @click="selectedMonth = month.key"
                >
                  <span>{{ month.month }}</span>
                  <span>{{ month.year }}</span>
                </button>
              </div>

              <div v-for="event in filteredEvents" :key="event.id" class="poi-event-card">
                <img
                  v-if="event.cover_image || event.cover || poiData.cover"
                  class="poi-event-image"
                  :src="hostAddress + (event.cover_image || event.cover || poiData.cover)"
                  alt=""
                />

                <div class="poi-event-content">
                  <div class="poi-event-title">
                    {{ event.name }}
                  </div>
                  <div class="poi-event-date">{{ formatDate(event.date_from) }} - {{ formatDate(event.date_to) }}</div>

                  <div class="poi-event-hour">
                    <span>
                      <template v-if="event.opening_hour || event.hour_from || event.time_from">
                        ⏰ {{ formatTime(event.opening_hour || event.hour_from || event.time_from) }}
                      </template>

                      <template v-if="event.closing_hour || event.hour_to || event.time_to">
                        - {{ formatTime(event.closing_hour || event.hour_to || event.time_to) }}
                      </template>
                    </span>
                  </div>
                  <div class="event-description">
                    <img src="@/assets/icons/info.png" alt="Info" class="info-icons" /><button
                      class="see-more-btns"
                      @click.stop="openEventDetails(event)"
                    >
                      See more information
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="filteredEvents.length === 0" class="no-events">Nu există evenimente în luna selectată.</div>
            </div>
          </div>
        </div>
        <div
          v-if="
            poiData.opening_hours ||
            poiData.long_info ||
            elevations ||
            (poiData.events && poiData.events.length) ||
            poiData.contact.website ||
            poiData.contact.tel1 ||
            poiData.contact.mail
          "
          class="addit-info"
          @click="showMore = !showMore"
        >
          {{ showMore ? $t("poiDetails.showLess") : $t("poiDetails.showMore") }}
        </div>
      </div>
    </div>
    <MapRouting
      v-if="showRoutingMap"
      :initialLat="initialLatFromPOI"
      :initialLng="initialLngFromPOI"
      :initialZoom="16"
      :end="{lat: poiStop.lat, lng: poiStop.lng}"
      @close="onRoutingClose"
    />
  </div>
</template>


<script>
import Vue from "vue";
import CategoryService from "@/services/category";
import M2wApi from "@/services/m2w_api";
import {basemap} from "@/services/map/basemap";
import {googleMaps} from "@/services/map/googleMaps";
import LineString from "ol/geom/LineString";
import Profil from "ol-ext/control/Profile";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Feature from "ol/Feature";
// import Point from "ol/geom/Point";
// import CircleStyle from "ol/style/Circle";
// import Stroke from "ol/style/Stroke";
import GPX from "ol/format/GPX";
import GeoJSON from "ol/format/GeoJSON";
import MapRouting from "@/components/MapRoutingMTK.vue";

export default {
  name: "PoiDetails",
  //components: {Carousel, Slide},
  components: {MapRouting},

  data() {
    return {
      weekDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      hostAddress: M2wApi.host_address,
      poiData: null,
      showMore: this.isDesktop(),
      prevRoute: null,
      elevations: null,
      coverLoaded: false,
      selected: 0,
      elevationProfileImage: null,
      elevationProfileSvg: null,
      isFlying: false,
      isPaused: false,

      showRoutingMap: false,
      initialLatFromPOI: null,
      initialLngFromPOI: null,
      poiStop: null,

      selectedMonth: null,
      months: [],
      activeTab: "info",
    };
  },
  computed: {
    isOpened: function () {
      return CategoryService.checkIfOpened(this.poiData);
    },
    openingHours: function () {
      return this.poiData.opening_hours;
    },
    parent: function () {
      return this.$route.query.parent;
    },
    websiteDisplay: function () {
      if (this.poiData.contact.web_label) return this.poiData.contact.web_label;

      let matches = this.poiData.contact.website.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
      if (matches) return matches[1];
      return "";
    },

    rotator() {
      const cover = this.poiData?.cover ?? this.poiData?.images?.coverUrl ?? null;

      const gallery = Array.isArray(this.poiData?.gallery)
        ? this.poiData.gallery
        : Array.isArray(this.poiData?.images?.gallery)
        ? this.poiData.images.gallery
        : [];
      const reversedGallery = [...gallery].reverse();

      return cover ? [cover, ...reversedGallery] : reversedGallery;
    },
    // rotator: function () {
    //   let tmp = [...this.poiData.gallery];
    //   if (this.poiData.cover) tmp.unshift(this.poiData.cover);
    //   return tmp;
    // },
    isWeatherMapActive() {
      return this.$root.weatherActive === true;
    },
    isLineGeometry() {
      return (
        this.poiData &&
        this.poiData.geom &&
        (this.poiData.geom.type === "LineString" || this.poiData.geom.type === "MultiLineString")
      );
    },
    isPointGeometry() {
      return (
        this.poiData &&
        this.poiData.geom &&
        (this.poiData.geom.type === "Point" || this.poiData.geom.type === "MultiPoint")
      );
    },
    showFlyButton() {
      return this.isLineGeometry && this.$root.weatherActive;
    },
    filteredEvents() {
      if (!this.poiData?.events) return [];

      return this.poiData.events.filter((e) => {
        const d = new Date(e.date_from);

        const key = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");

        return key === this.selectedMonth;
      });
    },
    hasMoreInfo() {
      return !!this.poiData?.long_info;
    },
    hasEvents() {
      return Array.isArray(this.poiData?.events) && this.poiData.events.length > 0;
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  watch: {
    "$route.params.id": async function (id, oldId) {
      if (id && parseInt(id) !== oldId) await this.fetchFromApi();
    },

    "$i18n.locale": async function () {
      await this.fetchFromApi();
    },

    poiData: {
      immediate: true,
      handler() {
        this.emitMtkHostsIfReady();
      },
    },
    isWeatherMapActive() {
      this.emitMtkHostsIfReady();
    },
    showMore(newVal) {
      this.$nextTick(this.emitMtkHostsIfReady);
      if (window.innerWidth <= 600) {
        document.body.classList.toggle("poi-expanded-mobile", newVal);
      }
    },
  },

  async mounted() {
    // this.$root.$emit("focusMapAfterAdding", this.poiData);
    this.$root.$on("mtkElevationProfileReady", this.onElevationProfileSvgReady);
    // this.$root.$on("mtkFlightControlReady", this.onFlightControlReady);

    this.$root.$on("flightFinished", () => {
      this.isFlying = false;
      this.isPaused = false;
    });

    this.$root.$on("mtkFlightControlReady", (flightDiv) => {
      const target = this.$refs.flightControlContainer;
      if (target && flightDiv) {
        target.innerHTML = "";
        target.appendChild(flightDiv);
      }
    });
    if (window.innerWidth <= 600 && this.showMore) {
      document.body.classList.add("poi-expanded-mobile");
    }

    await this.fetchFromApi();
    await this.$nextTick();
    this.emitMtkHostsIfReady();
  },

  deactivated() {
    document.body.classList.remove("poi-expanded-mobile");
    this.$layers.teardownSinglePoi(this.poiData);
    this.poiData = null;
    this.cleanUpHeightProfile();
  },

  beforeDestroy() {
    document.body.classList.remove("poi-expanded-mobile");
    this.closeFlight();
    this.$root.$off("mtkElevationProfileReady", this.onElevationProfileSvgReady);
    this.$layers.teardownSinglePoi(this.poiData);
    this.poiData = null;
    this.cleanUpHeightProfile();
    this.$root.$off("flightFinished");
    this.$root.$off("focusMapAfterAdding");
  },

  methods: {
    formatTime(time) {
      if (!time) return "";

      return String(time).slice(0, 5);
    },
    openEventDetails(event) {
      this.$router
        .push({
          name: "eventDetails",
          params: {
            id: event.id,
          },
          query: {
            ...this.$route.query,
            poi_id: this.poiData.id,
            parent: this.poiData.parent?.id || this.parent,
          },
        })
        .catch(() => {});
    },
    generateNextMonths(count = 24) {
      const result = [];
      const today = new Date();

      for (let i = 0; i < count; i++) {
        const d = new Date(today.getFullYear(), today.getMonth() + i, 1);

        result.push({
          key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`,
          month: d.toLocaleDateString(this.$i18n.locale, {month: "short"}),
          year: d.getFullYear(),
        });
      }

      return result;
    },
    formatDate(date) {
      if (!date) return "";

      return new Date(date).toLocaleDateString(this.$i18n?.locale || "ro", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    formatEventMonth(date) {
      if (!date) return "";

      const d = new Date(date);

      return d.toLocaleDateString(this.$i18n?.locale || "ro", {
        month: "short",
        year: "numeric",
      });
    },
    toAbsUrl(u) {
      if (!u) return "";
      if (/^https?:\/\//i.test(u)) return u;
      if (u.startsWith("//")) return "https:" + u;
      if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(u)) return "https://" + u;
      if (u.startsWith("/")) return this.hostAddress.replace(/\/$/, "") + u;

      return this.hostAddress.replace(/\/$/, "") + "/" + u;
    },
    //nou26.01
    emitMtkHostsIfReady() {
      if (!this.isWeatherMapActive) return;

      this.$nextTick(() => {
        if (this.isLineGeometry && this.$refs.elevationContainer) {
          this.$root.$emit("mtkElevationHostReady", this.$refs.elevationContainer);
        }
        if (this.isLineGeometry && this.$refs.flightControlContainer) {
          this.$root.$emit("mtkFlightHostReady", this.$refs.flightControlContainer);
        }
        this.$root.$emit("mtkUiHostsReady");
      });
    },
    onFlightControlReady(buttonEl) {
      const host = this.$refs.flightControlContainer;
      if (!host || !buttonEl) return;
      host.innerHTML = "";
      host.appendChild(buttonEl);
    },
    // onRoutingClick(e) {
    //   e?.stopPropagation?.();

    //   const g = this.poiData?.geom;
    //   if (!g) return;

    //   let c = null;
    //   if (g.type === "Point") c = g.coordinates;
    //   else if (g.type === "MultiPoint" && g.coordinates?.length) c = g.coordinates[0];
    //   if (!c) return;

    //   // EPSG:3857 vs lat/lng
    //   const looksLikeMerc = Math.abs(c[0]) > 180 || Math.abs(c[1]) > 90;
    //   const ll = looksLikeMerc
    //     ? googleMaps.transformToLatLngLiteral(c)
    //     : { lat: c[1], lng: c[0] };

    //   this.poiStart = { lat: ll.lat, lng: ll.lng };
    //   this.initialLatFromPOI = ll.lat;
    //   this.initialLngFromPOI = ll.lng;

    //   this.showRoutingMap = true;
    //   document.body.classList.add('routing-active');
    // },

    onRoutingClick(e) {
      e?.stopPropagation?.();

      const g = this.poiData?.geom;
      if (!g) return;

      let c = null;
      if (g.type === "Point") c = g.coordinates;
      else if (g.type === "MultiPoint" && g.coordinates?.length) c = g.coordinates[0];
      if (!c) return;

      // EPSG:3857 vs lat/lng
      const looksLikeMerc = Math.abs(c[0]) > 180 || Math.abs(c[1]) > 90;
      const ll = looksLikeMerc ? googleMaps.transformToLatLngLiteral(c) : {lat: c[1], lng: c[0]};

      // this.poiStart = { lat: ll.lat, lng: ll.lng };
      this.poiStop = {lat: ll.lat, lng: ll.lng};
      this.initialLatFromPOI = ll.lat;
      this.initialLngFromPOI = ll.lng;

      this.showRoutingMap = true;
      document.body.classList.add("routing-active");
    },

    onRoutingClose() {
      this.showRoutingMap = false;
      this.poiStop = null;
      this.$root.$emit("routingStatus", {isRoutingActive: false});
      document.body.classList.remove("routing-active");
    },

    async fetchFromApi() {
      this.$layers.teardownSinglePoi(this.poiData);
      this.poiData = null;
      const id = this.$route.params.id;
      this.poiData = await M2wApi.get_single_poi(id, this.$i18n.locale, this.parent);
      this.months = this.generateNextMonths(24);
      this.selectedMonth = this.months[0]?.key;
      console.log("POI DATA Criss:", this.poiData);
      console.log("POI LINE WIDTH:", {
        width: this.poiData?.width,
        line_width: this.poiData?.line_width,
        line_thickness: this.poiData?.line_thickness,
        style_width: this.poiData?.style?.width,
        style: this.poiData?.style,
      });
      await this.$nextTick();

      this.emitMtkHostsIfReady();
      await this.showOnMap();

      this.loadElevation();
      this.activeTab = this.hasMoreInfo ? "info" : "events";
    },

    async showOnMap() {
      let extent = await this.$layers.setupSinglePoi(this.poiData);
      basemap.map.getView().fit(extent, {duration: 500, minResolution: 1});
      this.$root.$emit("focusMapAfterAdding", this.poiData);
    },

    // async goBack() {
    //   this.closeFlight();
    //   if (this.parent) {
    //     await this.$router.push({name: "pois", query: {...this.$route.query, "toc-id": this.parent}});
    //   } else if (this.prevRoute.name != null) {
    //     this.$router.go(-1);
    //   } else {
    //     await this.$router.push({name: "default"});
    //   }
    // },
    async goBack() {
      document.body.classList.remove("poi-expanded-mobile");
      this.closeFlight();

      const is3D = this.$route.fullPath.includes("mtk=1");
      if (this.parent) {
        await this.$router.push({
          name: "pois",
          query: {
            ...this.$route.query,
            "toc-id": this.parent,
            ...(is3D ? {mtk: "1"} : {}),
          },
        });
        console.log("[goBack] revenire la categorie", is3D ? "(3D)" : "(OL)");
        return;
      }
      if (this.prevRoute) {
        const prevIs3D = this.prevRoute.fullPath?.includes("mtk=1");
        if (prevIs3D !== is3D) {
          await this.$router.push({
            name: "pois",
            query: {
              ...this.$route.query,
              ...(is3D ? {mtk: "1"} : {}),
            },
          });
          return;
        }
        this.$router.go(-1);
        return;
      }
      const defaultView = Vue.config.project.default_view || "/";
      await this.$router.push({
        path: defaultView,
        query: {
          ...this.$route.query,
          ...(is3D ? {mtk: "1"} : {}),
        },
      });
    },
    async loadElevation() {
      if (!this.poiData.geom.type.includes("LineString")) {
        return;
      }

      if (!this.poiData.parent.show_profile) {
        return;
      }

      let coordinates = this.poiData.geom.coordinates;
      if (this.poiData.geom.type === "MultiLineString") {
        coordinates = [].concat(...coordinates);
      }

      if (this.isWeatherMapActive) {
        this.$root.$emit("startElevationProfileMTK", coordinates);
        return;
      }

      let path = new LineString(coordinates);
      let gpath = path.getCoordinates().map((c) => googleMaps.transformToLatLngLiteral(c));
      try {
        const elevationData = await this.getElevationsInChunks(gpath);
        console.log("Elevation data loaded from Google:", elevationData.length, "points");
        this.plotElevationOL(elevationData);
      } catch (error) {
        console.error("Elevation query failed:", error);
      }
    },

    plotElevationOL(elevations) {
      this.elevations = elevations.map((e) => {
        let transformed = googleMaps.transformFromLatLng(e.location);
        return [transformed[0], transformed[1], Math.round(e.elevation)];
      });

      let geometry = new LineString(this.elevations);
      this.cleanUpHeightProfile();

      this.profile = new Profil({
        target: document.querySelector("#height-profile"),
        style: new Style({
          fill: new Fill({color: "#ccc"}),
        }),
        info: {
          altitude: this.$t("poiDetails.altitude"),
          zmin: this.$t("poiDetails.zmin"),
          zmax: this.$t("poiDetails.zmax"),
          distance: this.$t("poiDetails.distance"),
          time: this.$t("poiDetails.time"),
          ytitle: this.$t("poiDetails.altitude") + " (m)",
          xtitle: this.$t("poiDetails.distance") + " (km)",
        },
        width: 275,
        height: 190,
      });

      basemap.map.addControl(this.profile);
      this.profile.setGeometry(geometry);
    },

    cleanUpHeightProfile() {
      let elem = document.querySelector("#height-profile");
      if (elem) elem.innerHTML = "";
    },

    exportTrack(format) {
      let coords = this.poiData.geom.coordinates;
      if (this.poiData.geom.type === "MultiLineString") coords = Array.prototype.concat(...coords);
      let ls = new LineString(coords);
      let feature = new Feature(ls.simplify(0.5));
      let outputString;
      let options = {
        featureProjection: "EPSG:3857",
      };

      if (format === "gpx") outputString = new GPX().writeFeatures([feature], options);
      else if (format === "geojson") outputString = new GeoJSON().writeFeatures([feature], options);
      else return;

      let element = document.createElement("a");
      element.setAttribute("href", "data:application/gpx+xml;charset=utf-8," + encodeURIComponent(outputString));
      if (format === "gpx") element.setAttribute("download", "track.gpx");
      else element.setAttribute("download", "track.geojson");

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    isDesktop() {
      if (screen.width >= 600) {
        return true;
      } else {
        return false;
      }
    },
    getCoverBackground() {
      const color = this.poiData?.style?.fill_color ?? this.poiData?.parent?.style?.fill_color ?? null;

      const result = color ? {"background-color": color} : "";
      return result;
    },
    // async getElevationsInChunks(gpath, chunkSize = 200) {
    //   const elevator = new window.google.maps.ElevationService();
    //   let allResults = [];

    //   for (let i = 0; i < gpath.length; i += chunkSize) {
    //     const chunk = gpath.slice(i, i + chunkSize);
    //     const result = await new Promise((resolve, reject) => {
    //       elevator.getElevationForLocations({locations: chunk}, (res, status) => {
    //         if (status === "OK") resolve(res);
    //         else reject(status);
    //       });
    //     });
    //     allResults.push(...result);
    //   }

    //   return allResults;
    // },
    onElevationProfileSvgReady(profileElement) {
      const container = this.$refs.elevationContainer;
      if (!container) {
        console.warn("Container .height-profile container not foundt");
        return;
      }
      container.innerHTML = "";
      container.appendChild(profileElement);
      console.log("Moved original DOM into container");

      // Emit către WeatherMTK.vue
      // this.$root.$emit("elevationProfileReady", profileElement);
    },

    // onFlightControlReady(buttonElement) {
    //   const container = this.$refs.flightControlContainer;
    //   if (!container) {
    //     console.warn(" FlightControl container not found in PoiDetails");
    //     return;
    //   }

    //   container.innerHTML = "";
    //   container.appendChild(buttonElement);
    // },
    stopFlight() {
      this.isFlying = false;
      this.isPaused = false;
      this.$root.$emit("stopFlightControl");
      console.log("Stop to WeatherMTK.vue");
    },
    closeFlight() {
      this.stopFlight();
      this.$root.$emit("clearFlightPolyline");
    },
  },
};
</script>

<style scoped>
.poi-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.poi-name {
  flex: 0 1 85%;
  min-width: 0;
  font-weight: 600;
  /* white-space: nowrap; */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  hyphens: manual !important;
}

.poi-actions {
  flex: 0 0 15%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.action-btn {
  /* display: inline-flex; */
  align-items: center;
  gap: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 3px;
  background: #ecf0f3;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  border-radius: 8px;
  cursor: pointer;
  line-height: 1;
  transition: box-shadow 0.15s ease, transform 0.05s ease;
}

.action-btn:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.action-btn:active {
  transform: translateY(1px);
}

.action-icon {
  width: 24px;
  height: 24px;
}

.action-text {
  font-size: 14px;
}

@media (max-width: 520px) {
  .action-text {
    display: none;
  }
  .poi-actions {
    flex: 0 0 20%;
    gap: 6px;
  }
}

@media (max-width: 360px) {
  .poi-header {
    flex-wrap: wrap;
  }
  .poi-name {
    flex: 1 1 100%;
  }
  .poi-actions {
    flex: 1 1 100%;
    justify-content: flex-start;
  }
}

.flight-control-mount {
  display: contents;
}
</style>


<style>
body.routing-active #setting-buttons-wrapper {
  display: none !important;
}

body.routing-active .setting-buttons--secondary {
  display: none !important;
}

.mtk-elevation-svg {
  /* width: calc(100vw - 170px); */
  /* width: 350px; */
  height: 100px !important;
}

.mtk-elevation-background {
  height: 120px !important;
  max-height: 120px !important;
}
.mtk-elevation-profile text {
  font-size: 75px !important;
  font-family: Arial, sans-serif !important;
  padding: 2;
}

.mtk-elevation-curve-label {
  transform: translateY(-40px) !important;
  font-size: 85px !important;
  fill: #db0c0c;
}

@media (max-width: 768px) {
  .mtk-elevation-svg {
    width: calc(100vw - 50px);
    /* width: 260px; */
  }
}
/* .poi-events {
  margin-top: 12px;
} */

.poi-event-card {
  display: flex;
  margin-top: 8px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  border: 0;
  overflow: hidden;
  min-height: 120px;
}

.poi-event-image {
  width: 125px;
  min-width: 125px;
  height: 120px;
  object-fit: cover;
}

.poi-event-content {
  font-family: Quicksand;
  padding: 10px 12px;
  flex: 1;
}

.poi-event-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 10px;
}

.poi-event-date {
  display: inline-block;
  font-display: Quicksand;
  background: #d0d0d0;
  color: #464646;
  padding: 5px 9px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
}

/* .event-description {
  font-family: Quicksand;
  color: #777;
  font-size: 13px;
  line-height: 1.25;
} */

.events-months {
  display: flex;
  gap: 12px;
  /* padding: 10px; */
  background: #eef1f3;
  overflow-x: auto;
  padding-bottom: 12px;
  padding-top: 8px;
}

.events-months button {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border: 0;
  border-radius: 10px;
  background: #f4f4f4;
  color: #555;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.18);
  font-weight: 700;
}

.events-months button.active {
  background: #d0d0d0;
  color: #222;
}

.events-months button span {
  display: block;
  line-height: 1.1;
  font-size: 11px;
}

.tab-buttons {
  margin-bottom: 8px;
  display: flex;
  gap: 6px;
  /* margin-bottom: 12px; */
  /* border-top: 1px solid #a9a9a9; */
  border-bottom: 1px solid #a9a9a9;
  /* border-radius: 10px;  */
  /* box-shadow: 2px 4px 4px #999999; */
  transition: background 0.2s ease;
  /* border-radius: 0px 12px 0px 12px; */
  color: #777;
  font-weight: 600 !important;
}

.tab-buttons button {
  flex: 1;
  border: 0;
  /* border-radius: 10px; */
  padding: 9px 0px 9px;
  /* background: #666; */
  font-family: Quicksand, sans-serif;
  color: #777;
  font-weight: 600 !important;
  font-size: 16px;
  line-height: 1.3em;
  letter-spacing: 0.03em;
  text-align: center;
  text-align: left;
  /* border-bottom: #464646; */
}

.tab-buttons button.active {
  /* background: #333; */
  border-bottom: 2px solid #333333;
  color: #464646;
  /* background: #dadada; */
  /* box-shadow: 0px 4px 4px 0px #999999; */
  /* border-radius: 0px 12px 0px 12px; */
  transition: background 0.2s ease;
}
p.poi-events {
  font-family: Quicksand, sans-serif;
  color: #464646;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3em;
  letter-spacing: 0.03em;
  text-align: left;
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .tab-buttons button {
    flex: 1;
    border: 0;
    border-radius: 10px;
    padding: 9px;
    /* background: #666; */
    font-family: Quicksand, sans-serif;
    color: #464646;
    font-weight: 700;
    font-size: 13px;
    line-height: 1.3em;
    letter-spacing: 0.03em;
    text-align: left;
  }
}
.event-description {
  font-family: Quicksand;
  color: #777;
  font-size: 13px;
  line-height: 1.25;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  /* padding-top: 4px; */
  line-height: 1.3em;
}

.no-events {
  font-family: Quicksand;
  color: #777;
  font-size: 14px;
  line-height: 1.25;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  padding-top: 4px;
  line-height: 1.3em;
  padding-bottom: 9px;
}

.poi-event-hour {
  font-size: 13px;
}
.see-more-btns {
  font-family: Quicksand;
  color: #333;
  font-size: 13px;
  line-height: 1.25;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  padding-top: 8px;
  line-height: 1.3em;
}

.info-icons {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 8px;
}
</style>